import * as React from 'react'
import createSvgIcon from './createSvgIcon'
import styled from 'styled-components/macro'

const Notes = createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0_355_5370)">
      <path
        d="M5.25195 5C5.25195 4.46957 5.46267 3.96086 5.83774 3.58579C6.21281 3.21071 6.72152 3 7.25195 3H17.252C17.7824 3 18.2911 3.21071 18.6662 3.58579C19.0412 3.96086 19.252 4.46957 19.252 5V19C19.252 19.5304 19.0412 20.0391 18.6662 20.4142C18.2911 20.7893 17.7824 21 17.252 21H7.25195C6.72152 21 6.21281 20.7893 5.83774 20.4142C5.46267 20.0391 5.25195 19.5304 5.25195 19V5Z"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25195 7H15.252"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25195 11H15.252"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25195 15H13.252"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_355_5370">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.251953)"
        />
      </clipPath>
    </defs>
  </React.Fragment>,
  'Notes'
)

export default styled(Notes)`
  g {
    transform: translate(3px, 3px);
  }
`
